import { type GenerationToolGroup } from 'src/data/generationTool';
import { PROJECT_PANEL } from 'src/data/project';
import {
  PROJECT_TEMPLATE_POPUP_SIDEBAR_TAB,
  // @ts-expect-error - ProjectTemplatePopup has no TypeScript declarations
} from 'src/views/ProjectTemplatePopup';

export const MAX_DOCUMENT_WIDTH = 1124;
export const MIN_DOCUMENT_WIDTH = 680;
export const TOOLBAR_HEIGHT = 72;

export const DISPLAY_MODE = {
  document: 'document',
  list: 'list',
};
export type DisplayMode = (typeof DISPLAY_MODE)[keyof typeof DISPLAY_MODE];

export const clampDisplayMode = (mode: DisplayMode, defaultMode?: DisplayMode) => {
  const values = Object.values(DISPLAY_MODE);
  if (values.includes(mode)) {
    return mode;
  }
  return defaultMode;
};

export const PUBSUB_TOPIC_FILL_GUIDANCE_MODE_DATA = Symbol('TOPIC_FILL_GUIDANCE_MODE_DATA');

// The template entries open the gallery on their own tab; the rest are panel destinations, which
// is why only those are ever the sidebar's selection.
export const SIDEBAR_GENERIC_ITEM = {
  generationTemplates: 'generation_templates',
  savedTemplates: 'saved_templates',
  ...PROJECT_PANEL,
} as const;
export type SidebarGenericItem = (typeof SIDEBAR_GENERIC_ITEM)[keyof typeof SIDEBAR_GENERIC_ITEM];

const SIDEBAR_ITEM_TEMPLATE_TAB: Partial<Record<SidebarGenericItem, string>> = {
  [SIDEBAR_GENERIC_ITEM.generationTemplates]: PROJECT_TEMPLATE_POPUP_SIDEBAR_TAB.all,
  [SIDEBAR_GENERIC_ITEM.savedTemplates]: PROJECT_TEMPLATE_POPUP_SIDEBAR_TAB.savedTemplates,
};

/** The gallery tab a sidebar entry opens on, or nothing for the entries that fill the panel. */
export const getSidebarItemTemplateTab = (item: SidebarSelectedItem): string | undefined =>
  SIDEBAR_ITEM_TEMPLATE_TAB[item as SidebarGenericItem];

export type SidebarSelectedItem = SidebarGenericItem | GenerationToolGroup | null;

export const GENERATE_USING_OPTIONS = {
  defaultSuggestion: 'Default suggestion',
  removedTalkingPoints: 'Removed talking points',
  manualInstructions: 'Manual instructions',
} as const;
export type GenerateUsingOptions =
  (typeof GENERATE_USING_OPTIONS)[keyof typeof GENERATE_USING_OPTIONS];

export const DEFAULT_SUGGEST_IMPROVEMENT = 'Add engaging adjectives and verbs';

export const IMPORT_BRIEF_SOURCE = {
  fromUrl: 'from_url',
  brandBrief: 'brand_brief',
} as const;
export type ImportBriefSource = (typeof IMPORT_BRIEF_SOURCE)[keyof typeof IMPORT_BRIEF_SOURCE];
